module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/img_doctor02-c967eea635c8de0893691243d13a60ac.jpg";